import React from 'react';
import {UseFormMethods, useWatch} from 'react-hook-form';
import {emailRegex} from '../../../../utils/email';
import {FormErrors} from '../types';
import {FormSection, StyledTextInput} from './styled';

interface Props {
  errors: FormErrors;
  register: UseFormMethods['register'];
  control: UseFormMethods['control'];
  labels: {
    email_address: string;
    email_address_invalid: string;
    required: string;
  };
}

export const EmailInputSection = ({
  labels,
  register,
  control,
  errors,
}: Props) => {
  const email: string | undefined = useWatch({
    control,
    name: 'email',
  });

  return (
    <FormSection short>
      <StyledTextInput
        name="email"
        label={labels.email_address}
        ref={register({
          required: labels.required,
          pattern: {
            value: emailRegex,
            message: labels.email_address_invalid,
          },
        })}
        errorMessage={errors.email?.message}
        value={email}
        isControlled={false}
        date-testid="hcEmailInput"
      />
    </FormSection>
  );
};
